import { getEnv } from "../env";

const basePath = "/service-skills/v1";

async function getBaseUrl() {
  const env = await getEnv();
  return (
    env.REACT_APP_API_GATEWAY_URL ||
    window.process?.env?.REACT_APP_API_GATEWAY_URL ||
    "http://10.10.10.100:8097"
  );
}

export const skillsService = {
  getAll: async () => {
    const baseURL = await getBaseUrl();
    const res = await fetch(`${baseURL}${basePath}/get/all`, {
      headers: { "Content-Type": "application/json" },
    });
    if (!res.ok) {
      throw new Error(`Erreur API Skills: ${res.status}`);
    }
    return res.json();
  },

  getSkillNames: async () => {
    const baseURL = await getBaseUrl();
    const res = await fetch(`${baseURL}${basePath}/get/skill-names`, {
      headers: { "Content-Type": "application/json" },
    });
    if (!res.ok) {
      throw new Error(`Erreur API Skills Names: ${res.status}`);
    }
    const data = await res.json();
    return data.skill_names || [];
  },
};
